<template>
  <div id="app">
    <header data-v-fae5bece class="header" role="banner">
      <div class="header-image-wrapper">
        <div class="header-image-bg appHeader">
          <img :src="(brandObj || {}).logoUrl || '/timecloud-logo-white.png'" />
        </div>
      </div>
    </header>
    <main class="container">
      <p class="error-msg" v-if="errorMsg">{{ errorMsg }}</p>
      <router-view v-if="render" />
    </main>

    <footer class="container">
      <div class="powered">
        <p>Powered by</p>
        <a target="_blank" href="https://jointimecloud.com/">
          <img src="./assets/timecloud-logo.png" />
        </a>
      </div>
    </footer>
    <FlashMessage position="right bottom" />
    <Modal />
    <v-offline
      online-class="network-overlay network-overlay--online"
      offline-class="network-overlay network-overlay--offline"
      @detected-condition="amIOnline">
      <template v-slot:[onlineSlot] :slot-name="onlineSlot">
        <OfflineScreen></OfflineScreen>
      </template>
      <template v-slot:[offlineSlot] :slot-name="offlineSlot">
        <OfflineScreen></OfflineScreen>
      </template>
    </v-offline>
  </div>
</template>
<script>
import VOffline from 'v-offline';
import Modal from './components/Modal';
import OfflineScreen from './components/OfflineScreen';
export default {
  name: 'App',
  components: {
    Modal,
    VOffline,
    OfflineScreen
  },
  data() {
    return {
      onLine: null,
      onlineSlot: 'online',
      offlineSlot: 'offline',
      errorMsg: null,
      publicPath: process.env.BASE_URL,
      brandObj: {
        name: 'Time Cloud Safe on Site',
        logoUrl: '/timecloud-logo-white.png',
        brandColor: '#231f20',
        css: 'header{background-color:#2B418B;}'
      },
      metaTitle: null,
      location: null,
      version: null,
      render: true
    };
  },
  computed: {},
  mounted() {
    this.setBranding(this.brandObj);
    this.pageTitle(this.$route.meta.title);
    
    this.$nextTick(() => {
      setInterval(() => {
        const v = new Date().getTime();
        this.axios.get(`${window.origin}/version.json?v=${v}`).then(response => {
          this.version = response.data.version
        }).catch(error => console.error(error))
      }, 5 * (60 * 1000))
    })
  },
  watch: {
    $route() {
      this.pageTitle(this.metaTitle);
    },
    version (newVersion, oldVersion) {
      if (oldVersion && newVersion !== oldVersion) location.reload(true)
    },
    onLine(newValue, oldValue) {
      if (oldValue === false && newValue === true) this.reload();
    }
  },
  methods: {
    amIOnline(e) {
      console.log(e)
      this.onLine = e;
    },
    pageTitle(value) {
      if (value) {
        this.metaTitle = value;
        document.title = this.metaTitle;
      }
    },
    setBranding(branding) {
      if (branding) {
        this.brandObj = branding;
        console.log('Setting CSS:', branding.css);

        if (branding.css) {
          const customStyle = document.querySelector('[data-branding-style]');
          if (customStyle) customStyle.remove();
          let style = document.createElement('style');
          style.setAttribute('data-branding-style', '');
          style.type = 'text/css';
          this.style = style; // a reference I store in the data hash

          try {
            var brandStyles = JSON.parse(branding.css);
            var jsonCSS = '';
            for (let [key, valueObj] of Object.entries(brandStyles)) {
              console.log(key, valueObj);
              if (typeof valueObj === 'object') {
                for (let [childKey, value] of Object.entries(valueObj)) {
                  if (value) {
                    jsonCSS += '.' + key + '{';
                    jsonCSS +=
                      childKey.replace(
                        /([A-Z])/g,
                        g => `-${g[0].toLowerCase()}`
                      ) +
                      ':' +
                      value +
                      ' !important';
                    jsonCSS += '}';
                  }
                }
              }
            }
            this.style.innerHTML = jsonCSS;
            document.head.appendChild(style);
          } catch (ex) {
            this.style.innerHTML = branding.css;
            document.head.appendChild(style);
          }
        } 
      }
    },
    reload() {
      this.render = false;
      this.$nextTick(() => {
        this.render = true;
      });
    }
  },
};
</script>
